import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
interface AccordionItem {
  title: string;
  image: string;
  description: string;
  linkText: string;
  linkUrl: string;
}
const items: AccordionItem[] = [{
  title: "Digitalização",
  image: "https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/sobrenos/representation-user-experience-interface-design.jpg",
  description: "Nos move a vontade de transformar processos manuais em fluxos digitais automáticos — para que seu negócio funcione mesmo quando você não está olhando.",
  linkText: "Saiba mais",
  linkUrl: "/sobre-nos#valores"
}, {
  title: "Crescimento",
  image: "https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/sobrenos/Captura%20de%20tela%202026-01-08%20152357.png",
  description: "Nos move ver buffets saindo do operacional e finalmente tendo tempo para crescer de forma sustentável e inteligente.",
  linkText: "Saiba mais",
  linkUrl: "/"
}, {
  title: "Inovação",
  image: "https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/sobrenos/Captura%20de%20tela%202026-01-08%20150433.png",
  description: "Nos move a certeza de que o setor de eventos merece tecnologia de ponta — e não soluções adaptadas de outros mercados.",
  linkText: "Saiba mais",
  linkUrl: "/"
}, {
  title: "Confiança",
  image: "https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/sobrenos/Gemini_Generated_Image_bgw49sbgw49sbgw4.png",
  description: "Nos move a responsabilidade de ser o parceiro que simplifica a conquista e a execução de cada evento, do início ao fim.",
  linkText: "Saiba mais",
  linkUrl: "/"
}];
interface HorizontalAccordionProps {
  className?: string;
}

const HorizontalAccordion = ({ className }: HorizontalAccordionProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return <section className={`py-6 md:py-10 bg-background ${className || ''}`}>
      <div className="container-custom">
        {/* Cards Container */}
        <div className="flex gap-3 md:gap-4 h-[400px] md:h-[500px]">
          {items.map((item, index) => <motion.div key={index} onClick={() => setActiveIndex(index)} className={`
                relative overflow-hidden rounded-3xl cursor-pointer
                transition-all duration-500 ease-in-out
                ${activeIndex === index ? "flex-[4]" : "flex-1"}
              `} layout>
              {/* Background Image */}
              <div 
                className="absolute inset-0 bg-cover" 
                style={{
                  backgroundImage: `url(${item.image})`,
                  backgroundPosition: index === 0 ? 'center 30%' : 'center'
                }} 
              />
              
              {/* Overlay for inactive cards */}
              <motion.div className="absolute inset-0 bg-black/30" animate={{
            opacity: activeIndex === index ? 0 : 0.4
          }} transition={{
            duration: 0.3
          }} />

              {/* Title on card - always bottom left */}
              <div className="absolute bottom-0 left-0 p-4 md:p-6">
                <motion.h3 className="text-white font-bold text-lg md:text-2xl drop-shadow-lg" style={{
              writingMode: activeIndex === index ? "horizontal-tb" : "vertical-rl",
              textOrientation: activeIndex === index ? "mixed" : "mixed",
              transform: activeIndex === index ? "none" : "rotate(180deg)"
            }} layout>
                  {item.title}
                </motion.h3>
              </div>
            </motion.div>)}
        </div>

        {/* Description below active card */}
        <div className="mt-6 min-h-[80px]">
          <AnimatePresence mode="wait">
            <motion.div key={activeIndex} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} style={{
            marginLeft: `calc(${activeIndex} * (100% / 7) + ${activeIndex * 0.75}rem)`
          }} className="max-w-xl">
              <p className="text-gray-700 text-base md:text-lg">
                {items[activeIndex].description}
              </p>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Gradient Headline */}
        <div className="mt-16 text-center">
          <h2 className="text-2xl md:text-4xl font-bold leading-tight pb-1 bg-gradient-to-r from-[#F25C05] to-[#820AD1] bg-clip-text text-transparent">
            A evolução digital que o setor de eventos esperava
          </h2>
        </div>
      </div>
    </section>;
};
export default HorizontalAccordion;